angular.module('webpanel').controller('SimOrderController', ['$scope', 'service', 'api', 'OrderService', function($scope, service, api, OrderService) {
	$scope.services = [];
	$scope.packageOrderList = [];

	$scope.currentServicesHidden = false;
	$scope.orderHasLoaded = false;
	$scope.serviceHasLoaded = false;

	$scope.successMsg = 'Dziękujemy za dokonanie zakupu. Pakiet będzie dostępny w ciągu kilku minut.'

	$scope.selectedPackage = null;
	$scope.verificationStep = 0;

	var getServices = function() {
		$scope.services = service.get();
		orderByPriority();

		$scope.currentServicesHidden = false;
		$scope.serviceHasLoaded = $scope.services.length;
		
		api.servicesGetForOrder('group', [103, 133].join(',')).then(function(response) {
			$scope.packageOrderList = response.data;
			$scope.orderHasLoaded = true;
		});
	}

	var orderByPriority = function() {
		if($scope.services.length) {
			$scope.services = $scope.services.sort(function(a,b) {
				return a.type - b.type;
			});
		}
	}

	var showNoPhonePopup = function() {
		var pop = $scope.popup.create();

		pop.setText('Brak numeru telefonu przypisanego do konta. '+
			'W celu zamówienia kanałów musisz uzupełnić numer telefonu w ustawieniach konta.');
		pop.addButton('Przejdź do danych konta', function() {
			$scope.location.path('/twoje-konto/twoje-dane');
		}, 'yes', true);
		pop.addButton('Nie teraz', angular.noop, 'no');

		$scope.popup.push(pop);
		$scope.clearOrderList();
	}

	service.addObserver('tvServiceServiceObserver', function(type, device) {
		switch(type) {
			case 'change':
				// czasem przychodzą eventy od poprzedniego urządzenia typu
				// stb bo jest race conditon przy automatycznej zmianie typu na simcard
				// i nie da się anulować promisa
				if(device.type === 'stb') return;
				getServices();
			break;
		}
	});

	$scope.$on('$destroy', function() {
		service.removeObserver('tvServiceServiceObserver');
	});

	$scope.toggleCurrent = function() {
		$scope.currentServicesHidden = !$scope.currentServicesHidden;
	}

	$scope.order = function(package) {
		if(!$scope.checkHasEmail()) return;
		if(!$scope.user.hasPhoneNumber()) {
			showNoPhonePopup() 
			return;
		}

		OrderService.setSelectedPackage(package);
        OrderService.setVerificationStep(1);
		$scope.analytics.trackEvent('order', 'select', package.name);
	}

	$scope.orderOnCancel = function() {
		OrderService.reset();
	}

	$scope.orderOnSuccess = function() {
		OrderService.reset();
		service.update();
	}

	if($scope.user.isDemo()) {
		$scope.showLoginPrompt(true);
	} else {
		getServices();
	}

}]);